/** The two CDP connector routes. Neither is a page. */
export const CDP_CONNECTORS = ['cdp_in', 'cdp_out'] as const;

export type CdpConnector = (typeof CDP_CONNECTORS)[number];

/**
 * Where each connector sends the reader, inside the Pipelines app.
 *
 * The mapping reads backwards until you take the Pipelines point of view: a
 * connector named for data coming **in** to Journeys is a Pipelines
 * *destination* (Journeys receives), and one named for data going **out** is a
 * Pipelines *source* (Journeys emits). The directory labels them "Receiving
 * data" and "Sending data" for the same reason.
 */
const PIPELINES_OVERVIEW = {
  cdp_in: '/pipelines/destinations/journeys',
  cdp_out: '/pipelines/sources/journeys',
} satisfies Record<CdpConnector, string>;

/** The workspace-scoped Pipelines URL a CDP connector route resolves to. */
export function cdpPipelinesUrl(connector: CdpConnector, workspaceId: string): string {
  // oxlint-disable-next-line local-rules/enforce-generate-path -- cross-app Pipelines (CDP) deep-link, not a Hydra router path
  return `/workspaces/${workspaceId}${PIPELINES_OVERVIEW[connector]}`;
}
